export default {
  /**
   * Обработка настроек компонентов
   */
  methods: {
    setOptions() {
      return new Promise(resolve => {
        if (!this.options) {
          resolve()
        }
        Object.keys(this.mutableOptions).forEach(key => {
          const keyObject = this.mutableOptions[key]
          if (typeof keyObject !== 'object') {
            const newValue =
              this.options[key] !== null && this.options[key] !== undefined
                ? this.options[key]
                : keyObject
            if (newValue !== null && newValue !== undefined) { this.mutableOptions[key] = newValue }
          } else if (Array.isArray(keyObject)) {
            const newValue =
              this.options[key] !== null && this.options[key] !== undefined
                ? [...this.options[key]]
                : keyObject
            if (newValue !== null && newValue !== undefined) { this.mutableOptions[key] = newValue }
          } else if (keyObject !== null) {
            Object.keys(keyObject).forEach(prop => {
              const newValue = this.$_getOptionsValue(key, prop)
              if (newValue !== null && newValue !== undefined) { keyObject[prop] = newValue }
            })
          } else if (keyObject === null && this.options[key]) {
            this.mutableOptions[key] = this.options[key]
          }
        })
        resolve()
      })
    },
    $_getOptionsValue(prop, value) {
      if (!this.options) {
        return null
      }
      const propertyOptions = this.options[prop]
      return propertyOptions ? propertyOptions[value] : null
    }
  },
  watch: {
    options: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (!newValue) { return }
        this.setOptions()
      }
    }
  },
  props: {
    options: {
      type: Object,
    },
  },
}
